import { AppChangeImageComponent } from './../app-change-image/app-change-image.component';
import { AppSimpleImageComponent } from './../app-simple-image/app-simple-image.component';
import { Observable, Subject } from 'rxjs';
import { AppState } from './../../../../core/reducers/index';
import { UsersService } from './../../../../api/users.service';
import { ActivatedRoute } from '@angular/router';
import {
  Component,
  OnInit,
  ChangeDetectorRef,
  Inject,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { User, currentUser } from '@app/core/auth';
import { Store, select } from '@ngrx/store';
import { environment } from '@app/../environments/environment';
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { AuthenticateService, RoleService } from '@app/api/api';
import { Location } from '@angular/common';
import { LayoutUtilsService } from '@app/core/_base/crud';
import { resolveSanitizationFn } from '@angular/compiler/src/render3/view/template';

@Component({
  selector: 'meu-app-profile',
  templateUrl: './app-profile.component.html',
  styleUrls: ['./app-profile.component.scss'],
})
export class AppProfileComponent implements OnInit {
  @Input() UserId: string;
  @Input() openFromManageUser = false;
  @Output() closeModalEditUser = new EventEmitter();
  lstRole = [];
  constructor(
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private userService: UsersService,
    private store: Store<AppState>,
    private ref: ChangeDetectorRef,
    private dialog: MatDialog,
    private toast: ToastrService,
    private authenticateService: AuthenticateService,
    private layoutUtilsService: LayoutUtilsService,
    private roleService: RoleService
  ) {}
  showChooseImage: boolean = false;
  avatar: string = '/assets/media/users/default.jpg';
  avatar$: any = new Subject();
  tabName: string = 'basic';
  myInfo: any;
  // "Thông tin thiết bị" in the sidebar is a parent item that expands into 2 sub-items
  // (Danh sách thiết bị / Thống kê thiết bị) when clicked.
  equipmentMenuExpanded = false;
  ngOnInit() {
    if (this.UserId) {
      this.getUserInfo();
    } else {
      this.getMyInfo();
    }

    if (!this.openFromManageUser) {
      this.activatedRoute.fragment.subscribe((data) => {
        switch (data) {
          case 'myOrder':
            this.tabName = 'myOrder';
            break;
          case 'myInquiries':
            this.tabName = 'myInquiries';
            break;
          case 'bookAddress':
            this.tabName = 'bookAddress';
            break;
          case 'myDebt':
            this.tabName = 'myDebt';
            break;
          case 'notifications':
            this.tabName = 'notifications';
            break;
          case 'myEquipmentStats':
            this.tabName = 'myEquipmentStats';
            this.equipmentMenuExpanded = true;
            break;
          case 'my-equipment':
          case 'myEquipment':
            this.tabName = 'my-equipment';
            this.equipmentMenuExpanded = true;
            break;
          case 'myTopProducts':
            this.tabName = 'myTopProducts';
            break;
          case 'company':
            this.tabName = 'company';
            break;
          case 'advance':
            this.tabName = 'advance';
            break;
          default:
            this.tabName = 'basic';
            this.location.replaceState('/myprofile' + '#' + 'basic');
            break;
        }
      });
    }
  }
  dataURItoBlob(Base64) {
    let dataURI = Base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, '');
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });
    return blob;
  }
  // Convert base64 --> file
  convertImageFile(base64, usercode) {
    const iRandom = Math.floor(Math.random() * (10000 - 10 + 1)) + 10;
    const date = new Date().valueOf();
    const imageName = '[avatar]' + '[' + date + ']' + '[' + usercode + ']' + '.jpeg';
    // call method that creates a blob from dataUri
    const imageBlob = this.dataURItoBlob(base64);
    const imageFile = new File([imageBlob], imageName, { type: 'image/jpeg' });
    return imageFile;
  }
  openModalImage() {    
    try {
      const dialogRef = this.dialog.open(AppSimpleImageComponent, {
        data: {
          image: this.avatar,
        },
        width: '430px',
        maxWidth: '95vw',
        maxHeight: '95vh',
        disableClose: false,
        panelClass: 'custom-dialog-container',
        autoFocus: false,
        restoreFocus: false
      });


      dialogRef.afterClosed().subscribe((result) => {
        
        if (result && result.data) {
          this.avatar = result.data;
          this.avatar$.next(this.avatar);
          
          // Call API upload avatar
          const BlobAvatar = this.convertImageFile(this.avatar, this.myInfo.id);
          this.userService
            .apiUsersIdUploadAvatarPut(this.myInfo.id, BlobAvatar)
            .subscribe((res) => {
              if (res.success) {
                if (this.openFromManageUser) {
                  this.getUserInfo();
                } else {
                  this.getMyInfo();
                }
                this.toast.success('Cập nhật thành công');
              } else {
                this.toast.error('Cập nhật không thành công');
              }
            }, (error) => {
              console.error('Error uploading avatar:', error);
              this.toast.error('Lỗi khi tải ảnh lên server');
            });
        }
      });
    } catch (error) {
      console.error('Error opening modal:', error);
      this.toast.error('Không thể mở modal chỉnh sửa ảnh');
    }
  }
  getMyInfo() {
    this.authenticateService.apiAuthenticateGetMyInfoGet().subscribe((res) => {
      if (res.success) {
        this.myInfo = res.user;
        if (this.myInfo.avatar != null) {
          this.avatar = environment.backendhost + this.myInfo.avatar;
        }
        this.avatar$.next(this.avatar);
      }
    });
  }

  activeAccount() {
    const action = 'Xác nhận';
    const title = this.myInfo && this.myInfo.disabled ? 'Mở tài khoản' : 'Khóa tài khoản';
    const description =
      'Bạn có chắc chắn muốn ' +
      (this.myInfo && this.myInfo.disabled ? 'mở lại' : 'khóa') +
      ' tài khoản này?';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.updateElement(
      action,
      '',
      title,
      description,
      waitDesciption
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      } else {
        this.userService
          .apiUsersIdPut(this.myInfo.id, { disabled: !this.myInfo.disabled })
          .subscribe((res) => {
            if (res.success) {
              this.toast.success('Thao tác thành công');
              this.getUserInfo();
            }
          });
      }
    });
  }

  getUserInfo() {
    this.userService.apiUsersIdGet(this.UserId).subscribe((res) => {
      if (res.success) {
        this.myInfo = res.data;
        if (this.myInfo.avatar != null) {
          this.avatar = environment.backendhost + this.myInfo.avatar;
        }
        this.avatar$.next(this.avatar);
      } else {
        this.toast.error(res.message);
      }
    });
  }

  changeTab(name) {
    this.tabName = name;
    if (!this.openFromManageUser) {
      this.location.replaceState('/myprofile' + '#' + name);
    }

    if (this.tabName == 'advance') {
      this.getLstRoleUser();
    }
  }

  toggleEquipmentMenu(): void {
    this.equipmentMenuExpanded = !this.equipmentMenuExpanded;
  }

  resetPassword(ID) {
    const action = 'Xác nhận';
    const title = 'Khôi phục mật khẩu';
    const description =
      'Người dùng sẽ nhận được email chứa đường dẫn yêu cầu thiết lập mật khẩu tại hộp thư: ' +
      this.myInfo.email;
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.updateElement(
      action,
      '',
      title,
      description,
      waitDesciption
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      } else {
        this.userService.apiUsersForgotPasswordPost(this.myInfo.email).subscribe((res) => {
          if (res.success) {
            this.toast.success('Thao tác thành công');
          }
        });
      }
    });
  }

  getLstRoleUser() {
    this.roleService.apiRolesGet().subscribe((res) => {
      if (res.success) {
        this.lstRole = res.data;

        this.getRoleOfUser(this.UserId);
      }
    });
  }

  getRoleOfUser(userId) {
    this.userService.apiUsersIdRolesGet(userId).subscribe((res) => {
      if (res.success) {
        this.myInfo.role = res.data ? res.data.id : null;
        console.log('role get', this.myInfo.role);
      }
    });
  }

  changeRoleUser(e) {
    const action = 'Xác nhận';
    const title = 'Thay đổi phân quyền';
    const description = 'Bạn có chắc muốn thay đổi phần quyền của tài khoản?' + this.myInfo.email;
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.updateElement(
      action,
      '',
      title,
      description,
      waitDesciption
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        this.getLstRoleUser();
      } else {
        this.userService.apiUsersIdRolesPost(this.UserId, e.value).subscribe((res) => {
          if (res.success) {
            this.toast.success('Cập nhật phân quyền thành công');
          } else {
            this.toast.success('Cập nhật phân quyền không thành công');
          }
        });
      }
    });
  }

  editBasicInfoEvent(event) {
    if (this.openFromManageUser) {
      this.getUserInfo();
      this.closeModalEditUser.emit();
    } else {
      this.getMyInfo();
    }
  }

  editCompanyInfoEvent(event) {
    this.closeModalEditUser.emit();
  }
}
